import packageJson from "../package.json";

export const DEBUG = process.env.NODE_ENV === "development";

// export const API_ROOT = DEBUG
//   ? "http://localhost:5001"
//   : "https://api-poster.shwaq.com";
// export const API_ROOT = "https://api-poster.shwaq.com";
export const API_ROOT = "https://poster-api.hsct.mn";
export const VERSION = packageJson.version;

export const DATE_FORMAT = "yyyy-MM-DD HH:mm:ss";
export const convertT = (value) => {
  return `${value?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}¥`;
  // return `${value?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}¥`;
};
